import React from 'react';

function LoginHolder({ children }) {
  return (
    <div className="row">
      <div className="col-10 row align-items-center mt-3 p-4 bg-white shadow-sm" style={{ margin: 'auto' }}>
        <div className="col-6 mr-4">
          <div className="app-welcome-title color-blue" role="heading" aria-level="2">
            Welcome
          </div>
          <div className="font-lg color-dark-grey" style={{ lineHeight: '1.6' }}>
            <p className="my-3">
              The
              {' '}
              <span className="font-bold">Regulatory</span>
              {' '}
              application enables CTSU Regulatory Office staff to
              review and process
              {' '}
              <span className="font-bold">
                regulatory approvals, maintain IRB/CIRB records, and complete administrative tasks related to regulatory
                processing and data management
              </span>
            </p>
          </div>
        </div>
        <div className="col-6 align-center ctep-login-wrapper">
          <div className="content-page-title color-dark-blue" role="heading" aria-level="3">
            CTEP-IAM Login
          </div>
          <div className="iframe-container">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default LoginHolder;
